module.exports = __webpack_public_path__ + "static/media/iconfinder_search_461380.bd350c61.svg";